import React from "react";

const CommentImg = ({ img }) => {
  return (
    <div className="max-w-[1320px] mx-auto -mt-8">
      <h1 className="md:text-[43px] text-[30px] text-center  font-bold text-[#1b0c3e] ">
        What they say about us
      </h1>
      <div className="py-16 overflow-x-scroll scrollbar-hide">
        <img
          src={img}
          className="max-w-[920px] lg:max-w-[1320px] mx-auto "
          alt=""
        />
      </div>
    </div>
  );
};

export default CommentImg;
